module.exports = __webpack_public_path__ + "img/Menu-11.cf6432a0.png";